import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import './App.scss';
import './dx-styles.scss';
import "./utils/bootstrap/bootstrap.min.css";
import { Container } from 'react-bootstrap';
import InvoiceStatus from './components/invoice/InvoiceStatus';
import OnHoldInvoices from './components/onhold/OnHoldInvoices';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
    return (
        <div className="wrapper">
            <div className="header">
                <div className="logo"></div>
                <div className={'title'}>
                    Invoice Status
                </div>
            </div>
            <div className="mainContent">
                <Container>
                    <Router>
                        <Routes>
                            <Route path="/" element={<InvoiceStatus />} />
                            <Route path="/OnHoldInvoices" element={<OnHoldInvoices />} />
                        </Routes>
                    </Router>
                </Container>
            </div>
            <div className="footer">
                Copyright © {(new Date().getFullYear())} San Bernardino County Auditor-Controller/Treasurer/Tax Collector - All Rights Reserved.
            </div>
        </div>
    );
}

export default App;